import * as React from 'react';
import {connect} from "react-redux";
import {RouteComponentProps} from 'react-router';
import {BrowserRouter as Router, Redirect, Route, Switch} from "react-router-dom";

import LoginContainer from "./LoginContainer";
import MainContainer from "./MainContainer";
import NotificationContainer from "./NotificationContainer";

import FullscreenComponent from "../components/FullscreenComponent/FullscreenComponent";
import ImprintPolicyComponent from "../components/ImprintPolicyComponent/ImprintPolicyComponent";
import VerticalGridComponent from "../components/VerticalGridComponent/VerticalGridComponent";

interface ITopLevelRouterContainerProps {
    loggedIn: boolean
}

class TopLevelRouterContainer extends React.PureComponent<ITopLevelRouterContainerProps> {
    public render() {
        return (
            <FullscreenComponent>
                <NotificationContainer/>
                <VerticalGridComponent>
                    {this.props.loggedIn ?
                        <MainContainer/>
                        :
                        <Router basename="/literature-assistent">
                            <Switch>
                                <Route path="/login" component={LoginContainer}/>
                                <Route path="/" component={(props: RouteComponentProps) =>
                                    <Redirect to={`/login/${props.history.location.search}`}/>}
                                />
                            </Switch>
                        </Router>
                    }
                    <ImprintPolicyComponent/>
                </VerticalGridComponent>
            </FullscreenComponent>
        );
    }
}

const mapStateToProps = (store: any) => ({
    loggedIn: store.io.loggedIn
});

export default connect(mapStateToProps)(TopLevelRouterContainer);



// WEBPACK FOOTER //
// ./src/containers/TopLevelRouterContainer.tsx